import React from 'react';
import { Code, Database, Wrench, Zap } from 'lucide-react';
import { mockSkills } from '../mock';

const Skills = () => {
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'language':
        return <Code size={20} />;
      case 'framework':
        return <Wrench size={20} />;
      case 'technique':
        return <Zap size={20} />;
      default:
        return <Database size={20} />;
    }
  };

  return (
    <section id="skills" className="relative py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Skills & Technologies</h2>
          <div className="w-20 h-1 bg-cyan-500 mx-auto"></div>
          <p className="text-white/60 mt-4 max-w-2xl mx-auto">
            Specialized in AI/ML technologies and modern development frameworks
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {mockSkills.map((skill, index) => (
            <div
              key={index}
              className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4 hover:bg-white/10 hover:border-cyan-500/50 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/20"
              style={{
                animationDelay: `${index * 0.05}s`
              }}
            >
              <div className="flex items-center gap-3">
                <div className="text-cyan-400 group-hover:scale-110 transition-transform duration-300">
                  {getCategoryIcon(skill.category)}
                </div>
                <span className="text-white font-medium">{skill.name}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-4 gap-6">
          <div className="text-center">
            <div className="text-4xl font-bold text-cyan-400 mb-2">2+</div>
            <div className="text-white/60 text-sm">Programming Languages</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-cyan-400 mb-2">5+</div>
            <div className="text-white/60 text-sm">AI Frameworks</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-cyan-400 mb-2">10+</div>
            <div className="text-white/60 text-sm">Technologies</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-cyan-400 mb-2">1+</div>
            <div className="text-white/60 text-sm">Years Experience</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;